/* One definition of an item's editable shape, shared by the Add wizard and the
   Edit screen. Without this the two screens would each carry their own copy of
   the same fifteen fields and drift apart the first time one changes. */

import { categoryMeta, AUTH_SOURCES } from "./categories.js";
import { today } from "./format.js";

export function blankForm(category = "Sneakers") {
  return {
    category,
    brand: "",
    model: "",
    colorway: "",
    sku: "",
    size: categoryMeta(category).hasSizes ? "10" : "",
    releaseDate: "",
    purchaseDate: today(),
    retail: "",
    value: "",
    purchasedFrom: "",
    authentication: AUTH_SOURCES[0],
    authDate: "",
    materials: {},
    status: "Light Rotation",
    photos: [],
  };
}

/** Turns a saved item back into form state. Numbers become strings because
 *  that is what text inputs hold; empty stays empty rather than "0". */
export function formFromItem(item) {
  return {
    category: item.category,
    brand: item.brand || "",
    model: item.model || "",
    colorway: item.colorway || "",
    sku: item.sku || "",
    size: item.size || "",
    releaseDate: item.releaseDate || "",
    purchaseDate: item.dateAdded || today(),
    retail: item.retail ? String(item.retail) : "",
    value: item.value ? String(item.value) : "",
    purchasedFrom: item.purchasedFrom || "",
    authentication: item.authentication || AUTH_SOURCES[0],
    authDate: item.authDate || "",
    materials: item.materials || {},
    status: item.status,
    // Carried so an edit round-trip can't drop them; photos are managed on the
    // item's detail screen, not in this form.
    photos: item.photos || [],
  };
}

/** Form state → the shape the data layer persists. */
export function payloadFromForm(form) {
  const meta = categoryMeta(form.category);
  return {
    category: form.category,
    brand: form.brand.trim(),
    model: form.model.trim(),
    colorway: form.colorway.trim(),
    sku: form.sku.trim(),
    size: meta.hasSizes ? form.size : null,
    releaseDate: form.releaseDate || null,
    dateAdded: form.purchaseDate,
    retail: Number(form.retail) || 0,
    value: Number(form.value) || Number(form.retail) || 0,
    purchasedFrom: form.purchasedFrom.trim(),
    authentication: form.authentication,
    authDate: form.authDate || null,
    materials: form.materials,
    status: form.status,
    photos: form.photos || [],
  };
}

/** Brand and model are the only fields the database insists on. */
export function isFormComplete(form) {
  return Boolean(form.brand.trim() && form.model.trim());
}

/** Changing category invalidates the material selections, since every category
 *  declares its own groups. Sizes only apply to categories that have them. */
export function withCategory(form, category) {
  return {
    ...form,
    category,
    materials: {},
    size: categoryMeta(category).hasSizes ? form.size || "10" : "",
  };
}

export function toggleMaterial(form, groupKey, value) {
  const current = form.materials[groupKey] || [];
  return {
    ...form,
    materials: {
      ...form.materials,
      [groupKey]: current.includes(value) ? current.filter((x) => x !== value) : [...current, value],
    },
  };
}
